
import React from 'react';
import { useState } from 'react';
import { Button, Row, Col,Modal } from 'react-bootstrap';
import Avatar from 'components/common/Avatar';
import defaultAvatar from 'assets/img/team/avatar.png';
import { Badge } from 'react-bootstrap';
import OnBoardingService from '../../app/directory/OnBoardingService';

const OnboardingTaskModal = ({ task,  showOnboardingTaskModal, setShowOnboardingTaskModal }) => {
  const handleMarkedAsReviewed = (identifier) => {
    OnBoardingService.markOnboardingTaskAsReviewed(identifier).then(() => {
      setShowOnboardingTaskModal(false);
    }).catch(error => {
      console.error('Error marking task as reviewed:', error);
    });
  }
  return (
    <Modal
      show={showOnboardingTaskModal}
      onHide={() => setShowOnboardingTaskModal(false)}
      
    >
      <Modal.Header closeButton>
        <h7>{task.title}</h7>
      </Modal.Header>
      <Modal.Body>
        <Row className="align-items-center mb-3">
          <Col xs={2}></Col>
          <Col xs={10} className="text-end">
            <Badge
              bg={
                task.priority === 'High'
                  ? 'danger'
                  : task.priority === 'Medium'
                  ? 'warning'
                  : 'info'
              }
            >
              {task.priority}
            </Badge>
            <Badge bg="secondary" className="ms-1">
              {task.type}
            </Badge>
            {task.dueDate && (
              <Badge bg="warning" className="ms-1">
                Due: {new Date(task.dueDate).toLocaleDateString()}
              </Badge>
            )}
            {task.status && (
              <Badge bg="success" className="ms-1">
                {task.status}
              </Badge>
            )}
            
          </Col>
        </Row>
        <Row className="align-items-center mb-3">
          <Col xs={2}>
            <Avatar
              status="online"
              src={task.employee?.avatar || defaultAvatar}
              size="2xl"
              className="me-3"
            />
          </Col>
          <Col xs={4}>
            <h6 className="mb-1">{task.employeeName}</h6>
          </Col>
        </Row>
        <p>{task.text}</p>
        {task.documents.length > 0 && (
          <>
            <h6>Files attached</h6>
            <ul>
              {task.documents.map((doc, index) => (
                <li key={index}>
                  <a href={doc.img} target="_blank" rel="noopener noreferrer">
                    {doc.name}
                  </a>
                </li>
              ))}
            </ul>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-success btn-sm" onClick={() => handleMarkedAsReviewed(task.id)}>
          Mark as reviewed
        </Button>
        <Button className="btn-secondary btn-sm" onClick={() => setShowOnboardingTaskModal(false)}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>  
  );
};
const OnboardingWidgetItem = ({ key, task }) => {
  const [selectedOnbardingTask, setSelectedOnboardingTask] = useState(null);
  const [showOnboardingTaskModal, setShowOnboardingTaskModal] = useState(false);
  console.log('OnboardingWidgetItem task:', task);
  const avatar = {
    status: 'online',
    src:
      task?.employee !== undefined && task.employee?.avatar !== null
        ? task.employee.avatar
        : defaultAvatar,
    size: '2xl'
  };
  return (
    <>
      <div
        key={key}
        className={`border p-3 mb-2 ${key ? 'bg-light' : ''}`}
      >
        <Row className="align-items-center" style={{ width: '100%' }}>
          <Col xs={8}>
            <Avatar {...avatar} className="me-3" />
            <span>{task.employeeName}</span>
          </Col>
          <Col xs={4} className="text-end">
            <Badge
              bg={
                task.priority === 'High'
                  ? 'danger'
                  : task.priority === 'Medium'
                  ? 'warning'
                  : 'info'
              }
            >
              {task.priority}
            </Badge>
            <Badge bg="secondary" className="ms-1">
              {task.type}
            </Badge>
            <Badge bg="success" className="ms-1">
              {task.status || 'N/A'}
            </Badge>
          </Col>
          <Col>
            <small className="text-500">
              Due:{' '}
              {task.dueDate
                ? new Date(task.dueDate).toLocaleDateString()
                : 'N/A'}
            </small>
          </Col>
        </Row>
        <Row className="align-items-center mt-2">
          <Col xs={12}>
            <h6 className="mb-1">{task.title}</h6>
          </Col>
        </Row>
        <Row className="align-items-center mt-2">
          <Col xs={12}>
            <p className="mb-1 text-700 fs--1">
              {task.documents.map((doc, index) => (
                <React.Fragment key={index}>
                  <a href={doc.img} target="_blank" rel="noopener noreferrer">
                    {doc.name}
                  </a>
                  {index < task.documents.length - 1 && ', '}
                </React.Fragment>
              ))}
            </p>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col xs={2}>
            <Button
              variant="outline-primary"
              size="sm"
              onClick={()=>{setSelectedOnboardingTask(task); setShowOnboardingTaskModal(true);}}
              className="border-300 me-1 btn-outline-light"
              ><small>See Details</small></Button>
           </Col>
        </Row>   
      </div>
      {showOnboardingTaskModal && <OnboardingTaskModal task={selectedOnbardingTask} showOnboardingTaskModal={showOnboardingTaskModal} setShowOnboardingTaskModal={setShowOnboardingTaskModal} />}
    </>
  );
};
export default OnboardingWidgetItem;